import { inject, Injectable, signal } from "@angular/core";
import { AppSettings, defaults } from "../config";
import { BehaviorSubject, Observable } from "rxjs";
import { TranslateService } from "@ngx-translate/core";

@Injectable({
  providedIn: "root",
})
export class CoreService {
  translate = inject(TranslateService);
  private optionsSignal = signal<AppSettings>(
    localStorage.getItem("Hub_Settings")
      ? JSON.parse(localStorage.getItem("Hub_Settings")!)
      : defaults
  );
  private notify$ = new BehaviorSubject<Record<string, any>>({});

  constructor() {
    this.notify$.next(this.optionsSignal());
    const savedLang = this.getLanguage();
    this.translate.setDefaultLang(savedLang);
    this.translate.use(savedLang);
  }

  // Observable for notification updates
  get notify(): Observable<Record<string, any>> {
    return this.notify$.asObservable();
  }

  // Get the current options
  getOptions(): AppSettings {
    return this.optionsSignal();
  }

  setOptions(options: Partial<AppSettings>) {
    this.optionsSignal.update((current) => ({
      ...current,
      ...options,
    }));
    this.notify$.next(this.optionsSignal);
    localStorage.setItem("Hub_Settings", JSON.stringify(this.optionsSignal()));
  }

  setLanguage(lang: string) {
    this.setOptions({ language: lang });
  }

  getLanguage() {
    return this.getOptions().language;
  }
}
